import { useEffect } from "react";

const TikTokCallback = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if(code){
      window.opener?.postMessage({ code }, window.location.origin);
      window.close();
    }
  }, []);

  return <h2 style={{color: 'blue',padding: "50px 30"}}>Authenticating...</h2>;
};

export default TikTokCallback;
